import { twMerge } from '@/styles/tailwindMergeConfig'

interface SkeletonProps {
  isLoading?: boolean
}

export function Skeleton({ isLoading }: SkeletonProps) {
  return (
    <main
      role="progressbar"
      className="flex h-screen w-full flex-col items-center px-7"
    >
      <header
        className={twMerge(
          isLoading && 'animate-pulse',
          'mt-6 flex w-full max-w-screen-xl items-start justify-between pt-3 font-mono'
        )}
      ></header>

      <section
        className={twMerge(
          isLoading && 'animate-pulse',
          'mt-6 flex h-[calc(100vh-12rem)] w-full max-w-screen-xl flex-col gap-6 lg:flex-row '
        )}
      >
        <div className="flex size-full flex-col items-start gap-2">
          <span className="h-8 w-20 rounded bg-cromai-m3-sys-light-surface-variant dark:bg-cromai-m3-sys-dark-surface-variant" />
          <div
            className={twMerge(
              'bg-cromai-m3-sys-light-surface-variant dark:bg-cromai-m3-sys-dark-surface-variant',
              ' flex h-full w-full rounded'
            )}
          ></div>
        </div>

        <div className="flex size-full flex-col gap-2 lg:w-[500px]">
          <div className="flex gap-2 lg:w-[500px] justify-end">
            <div className="h-8 w-28 rounded bg-cromai-m3-sys-light-surface-variant dark:bg-cromai-m3-sys-dark-surface-variant" />
            <div className="h-8 w-28 rounded bg-cromai-m3-sys-light-surface-variant dark:bg-cromai-m3-sys-dark-surface-variant" />
          </div>
          <div className="flex size-full flex-col items-start overflow-auto rounded bg-cromai-m3-sys-light-surface-variant px-6 py-4 font-mono text-labelLarge dark:bg-cromai-m3-sys-dark-surface-variant"></div>
        </div>
      </section>
    </main>
  )
}
